import { Taxonomy } from "../types/Taxonomy"
import axios from "axios"
import { url } from "../helper"
import { defineStore } from "pinia"
import { reactive } from "vue"
import { useI18n } from "vue-i18n"

interface MovieType {
	categories: Taxonomy[]
	quality: Taxonomy[]
	type: Taxonomy[]
	appropriateness: Taxonomy[]
	features: Taxonomy[]
	casting: Taxonomy[]
}

export const useTaxonomyStore = defineStore("useTaxonomyStore", () => {
	const { locale } = useI18n()
	const state = reactive<MovieType>({
		appropriateness: [],
		categories: [],
		quality: [],
		type: [],
		features: [],
		casting: [],
	})

	const getCategories = async () => {
		try {
			await axios
				.get(
					`${url}/${locale.value}/jsonapi/taxonomy_term/category?sort=weight&jsonapi_include=1&filter[langcode]=${locale.value}`,
					{}
				)
				.then((res) => {
					state.categories = res.data.data
				})
		} catch (error) {
			console.log(error)
		}
	}

	const getAppropriateness = async () => {
		try {
			await axios.get(`${url}/jsonapi/taxonomy_term/appropriateness?jsonapi_include=1`, {}).then((res) => {
				state.appropriateness = res.data.data
			})
		} catch (error) {
			console.log(error)
		}
	}

	const getFeatures = async () => {
		try {
			await axios
				.get(
					`${url}/${locale.value}/jsonapi/taxonomy_term/features?jsonapi_include=1&filter[langcode]=${locale.value}`,
					{}
				)
				.then((res) => {
					state.features = res.data.data
				})
		} catch (error) {
			console.log(error)
		}
	}
	const getCasting = async () => {
		try {
			await axios.get(`${url}/jsonapi/taxonomy_term/casting?jsonapi_include=1`, {}).then((res) => {
				state.casting = res.data.data
			})
		} catch (error) {
			console.log(error)
		}
	}

	const getQuality = async () => {
		try {
			await axios.get(`${url}/jsonapi/taxonomy_term/quality?jsonapi_include=1`, {}).then((res) => {
				state.quality = res.data.data
			})
		} catch (error) {
			console.log(error)
		}
	}

	const getType = async () => {
		try {
			await axios
				.get(`${url}/${locale.value}/jsonapi/taxonomy_term/type?jsonapi_include=1&filter[langcode]=${locale.value}`, {})
				.then((res) => {
					state.type = res.data.data
				})
		} catch (error) {
			console.log(error)
		}
	}

	const getCategoryTitles = (field_category: { meta: { drupal_internal__target_id: string } }[]) => {
		if (!field_category || field_category.length === 0) {
			return ""
		}
		return field_category
			.map((item) => {
				return item?.name
			})
			.join(", ")
	}
	const getFeaturesTitle = (field_features: any) => {
		if (!field_features) {
			return ""
		}
		// Normalize possible shapes into an array
		const items = Array.isArray(field_features)
			? field_features
			: Array.isArray(field_features?.data)
			? field_features.data
			: field_features?.data
			? [field_features.data]
			: [field_features]

		if (!items || items.length === 0) {
			return ""
		}

		return items
			.map((item: any) => {
				return item?.name
			})
			.join(", ")
	}

	const getCastingTitles = (field_cast: { meta: { drupal_internal__target_id: string } }[]) => {
		if (!field_cast || field_cast.length === 0 || field_cast.data) {
			return ""
		}
		return field_cast
			.map((item) => {
				return item?.name
			})
			.join(", ")
	}
	const getCategoryTitle = (id: number) => {
		if (!id) {
			return ""
		}
		return state.categories.find((cat) => cat.drupal_internal__tid === id)?.name
	}

	const getQualityTitle = (id: number) => {
		if (!id) {
			return ""
		}
		return state.quality.find((cat) => cat.drupal_internal__tid === id)?.name
	}
	const getTypeTitle = (field_type: Array<{ meta: { drupal_internal__target_id: string } }>) => {
		if (!field_type || field_type.length === 0 || field_type.data) {
			return ""
		}
		let fieldType = field_type
			.map((item) => {
				return item?.name
			})
			.join(", ")
		return fieldType
	}
	const getAppropriatenessTitle = (id: number) => {
		return state.appropriateness.find((cat) => cat.drupal_internal__tid === id)?.name
	}

	return {
		state,
		getAppropriateness,
		getAppropriatenessTitle,
		getCasting,
		getCastingTitles,
		getFeatures,
		getFeaturesTitle,
		getType,
		getTypeTitle,
		getQuality,
		getQualityTitle,
		getCategories,
		getCategoryTitle,
		getCategoryTitles,
	}
})
